import { Box, Card, CardBody, Flex, Text } from "@chakra-ui/react";
import { RichText } from "@graphcms/rich-text-react-renderer";
import { RichTextContent } from "@graphcms/rich-text-types";
import { customRichText } from "components/individuals/mdx-components";
import Image from "next/image";
import { TestimonialProps } from "./testimonials";

export const TestimonialCard = ({
  highlight,
  picture,
  content,
  name,
  jobTitle,
  location,
}: TestimonialProps) => {
  const defaultFontSize = {
    base: 14,
    lg: 16,
  };

  return (
    <Card
      borderRadius={"xl"}
      w={{
        base: "80%",
        sm: "60%",
        md: "40%",
        lg: "30%",
        xl: "25%",
      }}
      py={{
        base: 6,
        md: 7,
        lg: 9,
      }}
      px={{
        base: 5,
        md: 6,
        lg: 8,
      }}
      shadow={"lg"}
      border={"1px"}
      borderColor={"gray.400"}
      h={{
        base: "300px",
        md: "350px",
        lg: "400px",
      }}
    >
      <CardBody p={0}>
        <Flex flexDir={"column"} justify={"space-between"} h={"full"}>
          <Box>
            <Text
              fontWeight={"bold"}
              fontSize={{
                base: "15px",
                md: "17px",
                lg: "18px",
                xl: "19px",
              }}
              pb={{
                lg: 2,
              }}
            >
              {highlight}
            </Text>
            <RichText
              content={content?.raw as RichTextContent}
              renderers={customRichText("black", 1.5, 4, defaultFontSize)}
            />
          </Box>
          <Flex flexDir={"row"} gap={5} align={"flex-start"}>
            <Box w={"60px"} h={"60px"}>
              <Image
                {...picture}
                src={picture?.url as string}
                height={picture?.height}
                width={picture?.width}
                alt={`${name} photo icon`}
                placeholder={
                  typeof picture?.blurDataURL === "string" ? "blur" : undefined
                }
                blurDataURL={
                  typeof picture?.blurDataURL === "string"
                    ? picture?.blurDataURL
                    : undefined
                }
              />
            </Box>
            <Box height={"min"}>
              <Text
                fontWeight={"bold"}
                fontSize={{
                  base: "15px",
                  md: "17px",
                  lg: "18px",
                  xl: "19px",
                }}
              >
                {name}
              </Text>
              <Text
                fontSize={defaultFontSize}
                color={"gray.500"}
                fontWeight={"medium"}
              >
                {jobTitle}
              </Text>
              <Text
                fontSize={defaultFontSize}
                color={"gray.500"}
                fontWeight={"medium"}
              >
                {location}
              </Text>
            </Box>
          </Flex>
        </Flex>
      </CardBody>
    </Card>
  );
};
